import { Button, Popover, Stack } from "@mantine/core";
import PopOver from "../../../../../components/View/PopOver";
import {
  IconChevronDown,
  IconChevronLeft,
  IconLayersSelected,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import UndoubleBlacklist from "./UndoubleBlacklist";
import UndoubleUnsub from "./UndoubleUnsub";
import UndoubleFromAnotherList from "./UndoubleFromAnotherList";

const UndoubleList = ({ id, onFinish }) => {
  const lang = useLanguage((s) => s.language);

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          className="to-blue"
          variant="light"
          justify="start"
          ref={ref}
          rightSection={<IconChevronDown size={16} />}
          leftSection={<IconLayersSelected size={18} />}
          styles={{
            label: {
              marginRight: "auto",
            },
          }}
          onClick={handleOpen}
          color="red"
        >
          {lang.contact_lists.undouble.label}
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack gap={"xs"}>
          <Popover
            zIndex={1600}
            position="left"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Button
                variant="subtle"
                size="sm"
                color="red"
                justify="start"
                leftSection={<IconChevronLeft size={16} />}
              >
                {lang.contact_lists.undouble.label_list}
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <UndoubleFromAnotherList
                handleClose={handleClose}
                id={id}
                onFinish={onFinish}
              />
            </Popover.Dropdown>
          </Popover>
          <Popover
            zIndex={1600}
            position="left"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Button
                variant="subtle"
                size="sm"
                color="red"
                justify="start"
                leftSection={<IconChevronLeft size={16} />}
              >
                {lang.contact_lists.undouble.label_blacklist}
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <UndoubleBlacklist
                handleClose={handleClose}
                id={id}
                onFinish={onFinish}
              />
            </Popover.Dropdown>
          </Popover>
          <Popover
            zIndex={1600}
            position="left"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Button
                variant="subtle"
                s
                size="sm"
                color="red"
                justify="start"
                leftSection={<IconChevronLeft size={16} />}
              >
                {lang.contact_lists.undouble.label_unsub}
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <UndoubleUnsub
                handleClose={handleClose}
                id={id}
                onFinish={onFinish}
              />
            </Popover.Dropdown>
          </Popover>
        </Stack>
      )}
    />
  );
};

export default UndoubleList;
